import { IonIcon } from '@ionic/react'
import { Flex } from 'antd'
import {
  bagHandleOutline,
  balloonOutline,
  barbellOutline,
  baseballOutline,
  beerOutline,
  bowlingBallOutline,
  cafeOutline,
  cardOutline,
  carOutline,
  cashOutline,
  checkmarkCircleOutline,
  closeCircleOutline,
  diamondOutline,
  filmOutline,
  flashOutline,
  giftOutline,
  golfOutline,
  heartOutline,
  iceCreamOutline,
  musicalNoteOutline,
  musicalNotesOutline,
  pawOutline,
  pizzaOutline,
  receiptOutline,
  restaurantOutline,
  rocketOutline,
  roseOutline,
  snowOutline,
  sparklesOutline,
  starOutline,
  storefrontOutline,
  ticketOutline,
  trainOutline,
  trophyOutline,
  walletOutline,
  wifiOutline,
  wineOutline,
} from 'ionicons/icons'

export interface IonIconPickerProps {
  value?: string
  onChange?: (value: string) => void
}

const IonIconPicker = ({ value, onChange }: IonIconPickerProps) => {
  const picasso: Record<string, string> = {
    'ticket-outline': ticketOutline,
    'restaurant-outline': restaurantOutline,
    'cash-outline': cashOutline,
    'wallet-outline': walletOutline,
    'card-outline': cardOutline,
    'gift-outline': giftOutline,
    'bag-handle-outline': bagHandleOutline,
    'balloon-outline': balloonOutline,
    'baseball-outline': baseballOutline,
    'barbell-outline': barbellOutline,
    'beer-outline': beerOutline,
    'bowling-ball-outline': bowlingBallOutline,
    'cafe-outline': cafeOutline,
    'checkmark-circle-outline': checkmarkCircleOutline,
    'close-circle-outline': closeCircleOutline,
    'diamond-outline': diamondOutline,
    'film-outline': filmOutline,
    'flash-outline': flashOutline,
    'heart-outline': heartOutline,
    'golf-outline': golfOutline,
    'ice-cream-outline': iceCreamOutline,
    'musical-notes-outline': musicalNotesOutline,
    'musical-note-outline': musicalNoteOutline,
    'paw-outline': pawOutline,
    'pizza-outline': pizzaOutline,
    'receipt-outline': receiptOutline,
    'rocket-outline': rocketOutline,
    'rose-outline': roseOutline,
    'sparkles-outline': sparklesOutline,
    'star-outline': starOutline,
    'storefront-outline': storefrontOutline,
    'snow-outline': snowOutline,
    'train-outline': trainOutline,
    'trophy-outline': trophyOutline,
    'wine-outline': wineOutline,
    'wifi-outline': wifiOutline,
    'car-outline': carOutline,
  }

  const handleSelect = (name: string) => {
    if (onChange) onChange(name)
  }

  return (
    <Flex gap={10} wrap="wrap">
      {Object.entries(picasso).map(([name, icon]) => (
        <Flex
          key={name}
          onClick={() => handleSelect(name)}
          style={{
            width: 35,
            height: 35,
            alignItems: 'center',
            justifyContent: 'center',
            padding: 5,
            borderRadius: 5,
            border: value === name ? '2px solid #5d5df6' : '2px solid #ccc',
            cursor: 'pointer',
          }}
        >
          <IonIcon
            icon={icon}
            style={{
              fontSize: 25,
            }}
          />
        </Flex>
      ))}
    </Flex>
  )
}

type IonIconPickerType = { Picker: typeof IonIconPicker }

export { IonIconPicker, type IonIconPickerType }
